<template>
  <div>
    <div v-if="!onlyForm">
      <div v-if="fetched && clientAssignedUserData.length > 0">
        <div
          v-for="(user, index) in clientAssignedUserData"
          :key="index"
          class="d-flex mb-3"
        >
          <div class="text-left">
            <vue-user :user="user.crm_user_info"> </vue-user>
          </div>
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-icon
              v-text="$getIcon('mdiStar')"
              v-if="user.primary"
              class="d-block"
              color="blue"
            >
            </v-icon>
            <a
              class="font-0 grey--text cursor-pointer"
              @click="
                (selectedClientAssignedUserData = user) &&
                  (clientAssignedUserForm = true)
              "
              >Update</a
            >
          </div>
        </div>
      </div>
      <div v-else>
        <vue-no-data
          :text="`Users have not been assigned to client yet.`"
        ></vue-no-data>
      </div>
    </div>
    <!-- Client Assigned User Form -->
    <v-navigation-drawer
      width="500"
      v-model="clientAssignedUserForm"
      right
      temporary
      fixed
      clipped
    >
      <template v-slot:prepend>
        <v-card flat tile>
          <vue-card-title
            :display-card.sync="clientAssignedUserForm"
            :title="cardTitle"
            :subtitle="
              'Fill up the following form to action on client assigned user.'
            "
            dark
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="clientAssignedUserForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text class="form-scroll">
            <client-assign-user-form
              v-if="selectedClientAssignedUserData && clientAssignedUserForm"
              :action-data="selectedClientAssignedUserData"
              @clientAssignedUserFormResponse="formSuccess"
              :client-slug="clientSlug"
            >
            </client-assign-user-form>
          </v-card-text>
        </v-card> </template
    ></v-navigation-drawer>
    <!-- / Client Assigned User Form -->
  </div>
</template>

<script>
import ClientAssignUserForm from "@/components/crm/client/forms/ClientAssignUserForm";

export default {
  components: { ClientAssignUserForm },
  props: {
    clientAssignedUserForm: {
      type: Boolean,
      default: false
    },
    clientSlug: {
      type: String,
      required: false,
      default() {
        return "";
      }
    },
    onlyForm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fetched: false,
      clientAssignedUserData: [],
      // form
      cardTitle: "",
      selectedClientAssignedUserData: {}
    };
  },
  watch: {
    clientAssignedUserForm(newVal) {
      this.$emit("update:assignedUserForm", newVal);
      if (
        Object.keys(this.selectedClientAssignedUserData).length > 0 &&
        newVal
      ) {
        this.cardTitle = "Update Client Assigned User";
      } else {
        this.selectedClientAssignedUserData = {};
        this.cardTitle = "Create Client Assigned User";
      }
    },
    clientSlug() {
      this.fetchClientAssignedUser();
    }
  },
  methods: {
    fetchClientAssignedUser() {
      const clientAssignedUserAPI = "/api/v1/crm/client-user/";
      this.fetched = false;
      const params = {
        client__slug: this.clientSlug
      };
      this.$axios.$get(clientAssignedUserAPI, { params }).then(response => {
        this.clientAssignedUserData = response;
        this.fetched = true;
      });
    },
    formSuccess() {
      this.$emit("formSuccess");
      this.clientAssignedUserForm = false;
      this.fetchClientAssignedUser();
    }
  }
};
</script>
